import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import {
  ApplicableProduct,
  CouponType,
  NormasTeachingCouponDTO,
} from "./useNormasTeachingCouponById.ts";

export function useUpdateNormasTeachingCoupon() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const updateNormasTeachingCoupon = async (
    couponId: string,
    input: {
      couponCode: string;
      value: { amount: number; couponType: CouponType };
      maxNumberOfUses: number;
      validFrom?: string;
      validTo?: string;
      applicableProducts?: ApplicableProduct[];
      isUnlimitedUses?: boolean;
    },
  ): Promise<NormasTeachingCouponDTO> => {
    try {
      setLoading(true);
      const { data } =
        await createAxiosInstance().post<NormasTeachingCouponDTO>(
          `/coupons/update/${couponId}`,
          input,
        );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateNormasTeachingCoupon,
    loading,
  };
}
